export const formatNumberInput = (
  inputValue: string | number | null,
  max: number,
  min: number,
  isDecimal: boolean
): number | null => {
  // Treat null/undefined/empty string as no value. Do NOT treat 0 as empty.
  if (inputValue === null || inputValue === undefined || inputValue === '') {
    return null;
  }

  // If it's a string, sanitize and convert to number
  if (typeof inputValue === 'string') {
    // Remove characters that can cause scientific notation or sign changes
    const sanitized = inputValue.replace(/[+\-eE]/g, '');
    if (sanitized.trim() === '' || sanitized === '.') {
      return null;
    }
    inputValue = Number(sanitized);
  }

  if (Number.isNaN(inputValue as number)) {
    return null;
  }

  let value = inputValue as number;

  // Clamp to bounds
  if (value < min) return min;
  if (value > max) return max;

  // Enforce integer when decimals are not allowed
  if (!isDecimal) {
    value = Math.trunc(value);
  }

  return value;
};